export function FileModel(data) {
    const { id, name } = data;

    const fileName = name.split("/").pop();

    return {
        id,
        name: fileName,
        url: name,
    };
}
